import _mapValues from "lodash/mapValues";
import Joi from "joi";

import { SettingsSchemaValuebets } from "./SettingsSchemaValuebets";

export class SettingsSchemaValuebetsLive extends SettingsSchemaValuebets {
  get subscriptionConfigSchema() {
    return {
      sports: Joi.array()
        .items(Joi.string().valid(...this.options.sportsList))
        .required(),
      sportsMarkets: Joi.object()
        .keys(
          _mapValues(this.options.markets, (marketsForASport) =>
            Joi.array().items(
              Joi.string()
                .valid(...marketsForASport)
                .required()
            )
          )
        )
        .required(),
      minPercentage: Joi.number().min(0).max(300).required(),
      maxPercentage: Joi.number().min(0).max(300).required(),
      excludedLeagues: Joi.array().items(Joi.string().max(80)).required(),
      minOdds: Joi.number().min(1).max(10000).required(),
			maxOdds: Joi.number().min(1).greater(Joi.ref('minOdds')).required(),
      nextPeriodSports: Joi.array().items(Joi.string().valid(...this.options.sportsList)).required(),
      minTime: Joi.number().min(0).required(),
      maxTime: Joi.number().greater(Joi.ref("minTime")).required(),
      pausedSports: Joi.array().items(Joi.string().valid(...this.options.sportsList)).required(),
    };
  }

  get configurationSchema() {
    const _subscriptionConfigSchema = this.subscriptionConfigSchema;

    return Joi.object({
      bookies: Joi.array()
        .items(Joi.string().valid(...this.options.bookiesList))
        .required(),
      ..._subscriptionConfigSchema,
      sortBy: Joi.string()
        .valid(...this.options.sortings.map((o) => o.type))
        .required(),
      subscriptionConfigs: Joi.object()
        .keys(
          Object.fromEntries(
            this.options.subscriptions.map((subscription) => [subscription, Joi.object(_subscriptionConfigSchema)])
          )
        )
        .required(),
    }).required();
  }

  get settingsSchema() {
    return Joi.object({
      _id: Joi.object({
        email: Joi.string(),
        id: Joi.string().required(),
      }),
      name: Joi.string().max(80).required(),
      type: Joi.string().valid("valuebetsLive").required(),
      defaultConfiguration: Joi.boolean().required(),
      version: Joi.string().max(10).required(),
      configuration: this.configurationSchema,
      addedOn: Joi.string(),
      updatedOn: Joi.string(),
    });
  }

  // Default configuration that concerns one arbitrage, i.e. a pair of bookies
  get defaultSubscriptionConfig() {
    return {
      sports: this.options.sportsList,
      sportsMarkets: this.options.markets,
      minPercentage: 0,
      maxPercentage: 300,
      minTime: 0,
      maxTime: 120,
      minOdds: 1,
      maxOdds: 10,
      nextPeriodSports: [],
      pausedSports: [],
      excludedLeagues: [], // list of strings used to match with league names that will be excluded
    };
  }

  // Default configuration for the arbitrages page
  get defaultConfiguration() {
    return {
      bookies: this.options.bookiesListExtended.filter(bookie => bookie.highlighted).map(bookie => bookie.bookie),
      sortBy: "timeDes",
      ...this.defaultSubscriptionConfig,
      subscriptionConfigs: {},
    };
  }

  get defaultSettings() {
    return {
      name: "Mi configuración",
      defaultConfiguration: false,
      configuration: this.defaultConfiguration,
      version: this.version,
      type: "valuebetsLive",
    };
  }

  get version() {
    return "1.1.1";
  }

  // Initialize all configurations per subscriptions with the default values
  // get defaultSubscriptionConfigs() {
  //   return this.subscriptions.reduce((config, subscription) => {
  //     config[subscription] = this.defaultSubscriptionConfig;
  //     return config;
  //   }, {});
  // }
}
